import {
  PROVIDERS_REQUEST_FAIL,
  PROVIDERS_REQUEST_SUCCESS,
  RESET_PROVIDERS
} from "../action.types";
import InitialState from "../initial.state";

export default (state = InitialState.providers, action) => {
  switch (action.type) {
    case PROVIDERS_REQUEST_SUCCESS:
      return action.payload;
    case PROVIDERS_REQUEST_FAIL:
      return state;
    case RESET_PROVIDERS:
      return InitialState.providers;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/provider/providers.reducer.js